import { defineComponent as _defineComponent } from 'vue';
import {} from "@fortawesome/fontawesome-svg-core";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import { useGlobalUploadModal } from "@/composables/globalUploadModal.js";
import { useUploadStore } from "@/stores/uploadStore";
import Query from "@/utils/query-string-parsing.js";
import ActivityItem from "@/components/ActivityBar/ActivityItem.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'UploadItem',
    props: {
        id: null,
        title: null,
        icon: null,
        tooltip: null
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const { openGlobalUploadModal } = useGlobalUploadModal();
        const { percentage, status } = storeToRefs(useUploadStore());
        onMounted(() => {
            if (Query.get("tool_id") == "upload1") {
                openGlobalUploadModal();
            }
        });
        function onUploadModal() {
            emit("click");
            openGlobalUploadModal();
        }
        return { __sfc: true, emit, openGlobalUploadModal, percentage, status, onUploadModal, ActivityItem };
    }
});
